export var CopyrightCheckerStatus;
(function (CopyrightCheckerStatus) {
    CopyrightCheckerStatus["WAITING"] = "waiting";
    CopyrightCheckerStatus["APPROVED"] = "approved";
    CopyrightCheckerStatus["CANCELLED"] = "cancelled";
    CopyrightCheckerStatus["PROCESSED"] = "processed";
    CopyrightCheckerStatus["NO_DOSSIER"] = "no_dossier";
    CopyrightCheckerStatus["DOMAIN_IGNORED"] = "domain_ignored";
})(CopyrightCheckerStatus || (CopyrightCheckerStatus = {}));
